<template>
  <div id="distribution_pop_three">
    <div class="pop_warp pop_flex">
      <div class="pop_box">
        <div class="pop_top">添加班级</div>
        <div class="pop_middle">
          <div class="mid_box">
            <div v-for="(item, index) in gradeInfo" :key="index + 'cd'">
              <div style="font-weight: bold;">
                <a-checkbox @change="onCheckAllChange(item, index)" :checked="item.checkAll">{{item.val}}</a-checkbox>
              </div>
              <div class="pop_flex" style="flex-wrap: wrap;">
                <template v-for="(itemOne, indexOne) in classAllArr[index]">
                  <a-checkbox :key="indexOne + 'uj'" @change="onCheckChange(item, index, itemOne)" :checked="itemOne.checkFlag">{{itemOne.classItem}}</a-checkbox>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="pop_foot pop_flex">
          <a-button @click="updateRemoveHandle" style="margin-right: 8px;">取消</a-button>
          <a-button type="primary" @click="addHandle" :disabled="chooseNum">添加</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
// import STUDENTFUN from '@/util/studentFun'
import GradeFormat from '@/util/gradeFormat'

export default {
  name: 'DistributionPopThree',
  props: ['removeInfo', 'removeInfoOne', 'removeInfoTwo'],
  data (){
    return {
      stuInfoList: null,
      // gradeClassAll: null,
      indeterminate: false,
      classAllInfo: [],
      classAllArr: [],
      gradeInfo: null,
      chooseAllInfo: null
    }
  },
  computed: {
    ...mapState([
      'schoolInfos',
      'gradeClass',
      'userInfo'
    ]),
    chooseNum () {
      if (this.classAllInfo.length === 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    removeInfo () {
      this.classAllInfo = this.removeInfo
      this.chooseAllInfo = this.removeInfo
      this.gradeInfo = this.removeInfoOne
      this.classAllArr = this.removeInfoTwo
    }
  },
  mounted () {
    if (this.gradeClass) {
      let gradeOne = []
      let gradeTwo = []
      this.gradeClass.map(item => {
        if (!gradeOne.includes(item.ENTRYYEAR)) {
          gradeOne.push(item.ENTRYYEAR)
        }
      })
      gradeOne.sort((a, b) => b - a)
      gradeOne.map(item => {
        let newArr = []
        gradeTwo.push({checkAll: false, id: item, val: GradeFormat(item, this.userInfo.SCHOOL_TYPE)})
        let arrClass = this.gradeClass.filter(key => key.ENTRYYEAR === item)
        arrClass.map(part => {
          newArr.push({classItem: `${part.CLASS_ID}班`, checkFlag: false, id: item})
        })
        this.classAllArr.push(newArr)
      })
      this.gradeInfo = gradeTwo
    }
    // if (this.schoolInfos) {
    //   this.stuInfoList = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
    //   this.gradeClassAll = STUDENTFUN.uploadData(this.stuInfoList)
    //   if (this.gradeClassAll) {
    //     this.gradeInfo = this.gradeClassAll.gradeArr
    //     this.gradeClassAll.gradeArr.map(item => {
    //       item.checkAll = false
    //     })
    //     this.gradeClassAll.classMaps.forEach((val, key) => {
    //       let newArr = []
    //       val.map(item => {
    //         newArr.push({classItem: item, checkFlag: false, id: key})
    //       })
    //       this.classAllArr.push(newArr)
    //     })
    //   }
    //   console.log(this.gradeInfo)
    //   console.log(this.classAllArr)
    // }
  },
  methods: {
    ...mapMutations([
      'setPopThreeShow'
    ]),
    updateRemoveHandle () { // 取消按钮
      this.setPopThreeShow(false)
      this.gradeInfo.map(item => { // 将年级所有选中状态去除
        item.checkAll = false
      })
      this.classAllArr.map(item => { // 将班级所有选中状态去除
        item.map(itemOne => {
          itemOne.checkFlag = false
        })
      })
      if (this.chooseAllInfo) { // 判断是否点击过添加
        this.classAllInfo = this.chooseAllInfo
        this.chooseAllInfo.map(item => {
          if (item.classId) { // 判断当前项是否为班级
            this.classAllArr.map(itemOne => {
              itemOne.map(itemTwo => {
                if (itemTwo.id === item.id) {
                  if (itemTwo.classItem === item.classId) {
                    itemTwo.checkFlag = true
                  }
                }
              })
            })
          } else {
            this.gradeInfo.map(itemOne => {
              if (itemOne.id === item.id) {
                itemOne.checkAll = true
              }
            })
            this.classAllArr.map(itemOne => {
              itemOne.map(itemTwo => {
                if (itemTwo.id === item.id) {
                  itemTwo.checkFlag = true
                }
              })
            })
          }
        })
      } else {
        this.classAllInfo = []
      }
    },
    addHandle () { // 添加按钮
      this.setPopThreeShow(false)
      this.$emit('isDisabled', this.chooseNum)
      this.chooseAllInfo = this.classAllInfo
    },
    onCheckChange (value, index, val) { // 量表或游戏的选择
      let listFlag = []
      let chooseList = []
      let chooseListTwo = []
      this.classAllInfo.map(item => { // 将当前选中的年级班级的中文放入数组中
        chooseList.push(item.con)
      })
      // 判断班级有没有都被选中
      this.classAllArr[index].map(item => {
        if (item.classItem === val.classItem) {
          item.checkFlag ? item.checkFlag = false : item.checkFlag = true
        }
        listFlag.push(item.checkFlag)
      })
      if (listFlag.includes(false)) { // 班级没有全都选中
        this.gradeInfo[index].checkAll = false
        if (chooseList.includes(value.val)) { // 判断选中项中有没有该年级的全称
          const list = this.classAllInfo.filter(tag => tag.con !== value.val) // 有的话去除
          this.classAllInfo = list
          this.classAllArr[index].map(item => { // 同时将该年级下的所有班级添加入选中项中
            this.classAllInfo.push({con: `${value.val}${item.classItem}`, id: value.id, classId: item.classItem})
          })
        }
      } else { // 班级全都选中的状态
        this.gradeInfo[index].checkAll = true
        let list = this.classAllInfo.filter(tag => tag.id !== value.id) // 将同年级下的班级都去除
        this.classAllInfo = list
        this.classAllInfo.push({con: value.val, id: value.id}) // 将该年级添加入选中项中
      }
      this.classAllInfo.map(item => { // 将当前选中的年级班级的中文放入数组中
        chooseListTwo.push(item.con)
      })
      if (chooseListTwo.includes(`${value.val}${val.classItem}`)) { // 选择项中判断有无当前点击项
        const list = this.classAllInfo.filter(tag => tag.con !== `${value.val}${val.classItem}`)
        this.classAllInfo = list
      } else {
        if (listFlag.includes(false) && listFlag.length !== 1) {
          this.classAllInfo.push({con: `${value.val}${val.classItem}`, id: value.id, classId: val.classItem})
        }
      }
    },
    onCheckAllChange (value, index) {
      this.gradeInfo[index].checkAll ? this.gradeInfo[index].checkAll = false : this.gradeInfo[index].checkAll = true
      if (this.gradeInfo[index].checkAll) { // 当前点击的年级是否选中
        this.classAllArr[index].map(item => { // 当前年级下的班级都被选中
          item.checkFlag = true
        })
        let list = this.classAllInfo.filter(tag => tag.id !== value.id) // 将该年级下的班级都删除
        this.classAllInfo = list
        this.classAllInfo.push({con: value.val, id: value.id, flag: this.gradeInfo[index].checkAll})
      } else {
        this.classAllArr[index].map(item => {
          item.checkFlag = false
        })
        const list = this.classAllInfo.filter(tag => tag.con !== value.val)
        this.classAllInfo = list
      }
    }
  }
}
</script>

<style>
#distribution_pop_three {
  position: fixed;
  z-index: 10000;
  left: 0px;
  right: 0px;
  bottom: 0px;
  top: 0px;
  background-color: rgba(0, 0, 0, .4);
  color: #262626;
  overflow-y: auto;
}
#distribution_pop_three .pop_flex {
  display: flex;
}
#distribution_pop_three .pop_warp {
  width: 100%;
  padding: 140px 0px;
  box-sizing: border-box;
  height: auto;
  justify-content: center;
}
#distribution_pop_three .pop_box {
  width: 640px;
  background-color: #FFFFFF;
  border-radius: 4px;
}
#distribution_pop_three .pop_box .pop_top {
  padding: 16px 24px;
  border-bottom: 1px solid #EBEBEB;
  box-sizing: border-box;
  font-size: 16px;
}
#distribution_pop_three .pop_box .pop_middle {
  padding: 16px 24px 32px;
  box-sizing: border-box;
}
#distribution_pop_three .pop_box .pop_foot {
  padding: 16px;
  border-top: 1px solid #EBEBEB;
  box-sizing: border-box;
  justify-content: flex-end;
}
#distribution_pop_three .ant-checkbox-wrapper {
  flex-basis: 33%;
  margin-top: 16px;
}
#distribution_pop_three .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}
/* #distribution_pop_three .ant-checkbox-group-item {
  margin-right: 0px;
  margin-top: 16px;
} */
</style>
